import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6b707221")

_pushScopeId("data-v-6b707221")
const _hoisted_1 = { class: "constract-form-wrapper" }
const _hoisted_2 = {
  "aria-labelledby": "swal2-title",
  "aria-describedby": "swal2-content",
  class: "swal2-popup swal2-modal swal2-icon-info swal2-show",
  tabindex: "-1",
  role: "dialog",
  "aria-live": "assertive",
  "aria-modal": "true",
  style: {"display":"flex"}
}
const _hoisted_3 = { class: "swal2-header pl-0 align-items-start" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = {
  class: "swal2-content pl-0 pr-0",
  style: {"text-align":"start"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "col-6 mt-3" }
const _hoisted_11 = { class: "col-6 mt-3" }
const _hoisted_12 = { class: "swal2-actions" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "swal2-loader" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckBoxInput = _resolveComponent("CheckBoxInput")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h4", null, _toDisplayString(_ctx.$t('orderActions.contractForm.sendContractFormToCustomer')), 1),
        _hoisted_4,
        _createVNode("h5", null, _toDisplayString(_ctx.$t('orderActions.contractForm.additionalInfo')), 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('orderActions.contractForm.additionalInfoDescription')), 1),
        _createVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          class: "swal2-close",
          "aria-label": "Close this dialog",
          style: {"display":"flex"}
        }, "×")
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_CheckBoxInput, {
              modelValue: _ctx.contractForm.hasChangesAndCancellationsPolicy,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.contractForm.hasChangesAndCancellationsPolicy = $event)),
              name: "sms",
              value: "true",
              label: _ctx.$t('providers.contractForm.changesAndCancellationsPolicy')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_CheckBoxInput, {
              modelValue: _ctx.contractForm.hasPaymentConditions,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.contractForm.hasPaymentConditions = $event)),
              name: "sms",
              value: "true",
              label: _ctx.$t('providers.contractForm.paymentConditions')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_CheckBoxInput, {
              modelValue: _ctx.contractForm.hasBankAccountDetails,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.contractForm.hasBankAccountDetails = $event)),
              name: "sms",
              value: "true",
              label: _ctx.$t('providers.contractForm.bankAccountDetails')
            }, null, 8, ["modelValue", "label"])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", null, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('providers.email')) + ":", 1),
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.contractForm.customerEmail = $event)),
                type: "text",
                class: "bookit-input h-auto product-input"
              }, null, 512), [
                [_vModelText, _ctx.contractForm.customerEmail]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", null, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('orders.mobile')) + ":", 1),
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.contractForm.customerMobile = $event)),
                type: "text",
                class: "bookit-input h-auto product-input mobile-input"
              }, null, 512), [
                [_vModelText, _ctx.contractForm.customerMobile]
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode("button", {
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          type: "button",
          class: "swal2-deny close-button-wrapper popup-bookit-button my-1 px-5",
          style: {"display":"inline-block"}
        }, _toDisplayString(_ctx.$t('button.cancel')), 1),
        _createVNode("button", {
          class: [_ctx.confirmButtonClass(), "swal2-confirm save-button-wrapper popup-bookit-button my-1 px-5"],
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args))),
          disabled: !_ctx.canConfirm(),
          type: "button",
          style: {"display":"inline-block"}
        }, _toDisplayString(_ctx.$t('orderActions.contractForm.sendContractFormButton')), 11, ["disabled"])
      ])
    ])
  ]))
})